import { render, staticRenderFns } from "./productOrderDetalis.vue?vue&type=template&id=a1372098&scoped=true&"
import script from "./productOrderDetalis.vue?vue&type=script&lang=js&"
export * from "./productOrderDetalis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1372098",
  null
  
)

export default component.exports